import {CategoriesStore} from "./store/categories.store";
import {i18nModule} from "@config/i18n.module";
import {ResourcesModule} from "@resources/resources.module";
import {NgModule} from "@angular/core";
import {PanierStore} from "./store/panier.store";
import {UtilsModule} from "@common/utils/utils.module";
import {DynamicComponentModule} from "ng-dynamic";

var modulesImport: Array<any> = [
  /** Liste des modules */
  UtilsModule,
  ResourcesModule,
  i18nModule,
  DynamicComponentModule.forRoot({
    imports: [UtilsModule, i18nModule]
  })
];

var modulesExport: Array<any> = [
  /** Liste des modules */
  UtilsModule,
  ResourcesModule,
  i18nModule,
  DynamicComponentModule
];

@NgModule({
  imports: modulesImport,
  exports: modulesExport,
  providers: [
    PanierStore, CategoriesStore
  ]
})
export class CerbaCommonModule {

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/common/cerba-common.module.ts